module.exports = __webpack_public_path__ + "img/blog_menu_pic3.a03f6fcb.png";